module["exports"] = [
  "(0##) ### ####",
  "0## ### ####",
  "+27 ## ### ####",
  "01# ### #####",
  "02# ### #####",
  "03# ### #####",
  "04# ### #####",
  "05# ### #####",
  "0800 ### ###",
  "0860 ### ###",
  "01#########",
  "01# ########"
];


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_ZA/phone_number/formats.js
// module id = 2789
// module chunks = 1610